module.exports = __webpack_public_path__ + "files/4de80a92751ad88995487108d0d87156.png";